import {
  api_url,
  legendLabelsBoxHeightLine,
  configChartsColorPalettes,
  yRight,
  partSumpTrajectory,
  popupInformation,
  defaultDatalabelsAlign,
  defaultDatalabelsAnchor,
  defaultDatalabelsFontWeight,
  defaultTicksCustomValue,
} from "../../../utils";

const DureeMoyenneTrajet = {
  checked: false,
  titleSideBar: "Tiempo promedio de viaje",
  titleIndicator: "SUMP Trajectory Content.charts.DureeMoyenneTrajet.title",
  popupInformation: {
    status: "false",
    text: popupInformation[partSumpTrajectory]["dureeMoyenneTrajet"],
  },
  keyFigure: {
    typeUpdate: "geographical_area", // year or geographical_area
    label: "",
    url: "",
    separator: "",
    position: "",
  },
  charts: [
    {
      typeChart: "bar",
      typeLabels: "years", // years or geographical_areas
      multiYearGeographicalArea: true,
      singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
      titleChart: "",
      titleDisplay: "true",
      legendDisplay: "true",
      legendCustom: "false",
      legendLabelsBoxHeight: legendLabelsBoxHeightLine,
      maintainAspectRatio: true,
      indexAxis: "x", // x or y
      heightChart: "300",
      widthChart: "600",
      i18nKeyLabels:
        "SUMP Trajectory Content.charts.DureeMoyenneTrajet.axis.labelsX",
      scales: {
        x: {
          type: "category",
          display: true,
          stacked: false,
          titleDisplay: false,
          titleText: "",
          gridDisplay: false,
          beginAtZero: false,
          ticks: {
            display: true,
            value: defaultTicksCustomValue,
          },
        },
        y: {
          type: "linear",
          display: true,
          stacked: false,
          titleDisplay: true,
          titleText:
            "SUMP Trajectory Content.charts.DureeMoyenneTrajet.axis.titleY",
          gridDisplay: true,
          beginAtZero: true,
          max: 75,
          ticks: {
            display: true,
            value: {
              prefix: "",
              suffix: "",
            },
          },
        },
        yRight: yRight,
      },
      annotationsProperties: {
        annotation1: undefined,
        annotation2: undefined,
      },
      keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
      },
      datasets: [
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.DureeMoyenneTrajet.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en voiture",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet&trend=projection&chart=duree_moyenne_trajet_voiture&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_duree_moyenne_trajet"]
              .backgroundColor["0"],
          borderColor:
            configChartsColorPalettes["trajectory_duree_moyenne_trajet"]
              .borderColor["0"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: true,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "decimal",
            },
          },
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.DureeMoyenneTrajet.legend.HIDETOOLTIPIFZERODurée moyenne du trajet en bus",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet&trend=projection&chart=duree_moyenne_trajet_bus&chart_data=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes["trajectory_duree_moyenne_trajet"]
              .backgroundColor["1"],
          borderColor:
            configChartsColorPalettes["trajectory_duree_moyenne_trajet"]
              .borderColor["1"],
          borderWidth: 2,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: true,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "decimal",
            },
          },
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.DureeMoyenneTrajet.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en voiture",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet&trend=projection&chart=duree_moyenne_trajet_voiture_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_duree_moyenne_trajet_objective_transparency"
            ].backgroundColor["0"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_duree_moyenne_trajet_objective_transparency"
            ].borderColor["0"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: true,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "decimal",
            },
          },
        },
        {
          type: "bar",
          label:
            "SUMP Trajectory Content.charts.DureeMoyenneTrajet.legend.HIDELEGENDHIDETOOLTIPIFZERODurée moyenne du trajet en bus",
          data: [],
          url:
            api_url +
            "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=duree_moyenne_trajet&trend=projection&chart=duree_moyenne_trajet_bus_objective&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
          backgroundColor:
            configChartsColorPalettes[
              "trajectory_duree_moyenne_trajet_objective_transparency"
            ].backgroundColor["1"],
          borderColor:
            configChartsColorPalettes[
              "trajectory_duree_moyenne_trajet_objective_transparency"
            ].borderColor["1"],
          borderWidth: 1,
          pointStyle: "circle",
          pointRadius: 3,
          spanGaps: true,
          legendCustomCssClass: "",
          fill: false,
          yAxisID: "y",
          order: 2,
          tooltipUnit: "",
          barPercentage: 1,
          categoryPercentage: 1,
          datalabelsProperties: {
            display: true,
            anchor: defaultDatalabelsAnchor,
            align: defaultDatalabelsAlign,
            font: {
              weight: defaultDatalabelsFontWeight,
            },
            value: {
              prefix: "",
              suffix: "",
              separator: "decimal",
            },
          },
        },
      ],
    },
  ],
};

export default DureeMoyenneTrajet;
